import { Outlet } from "react-router-dom";
import { FormProvider, useForm } from "react-hook-form";
import { PwdReqType } from "../../types/Login";

function AuthPage() {
  const resetForm = useForm<PwdReqType>({
    mode: "all",
  });

  return (
    <div className="safe-top-with-hanger safe-bottom-with-dock">
      <main className="flex flex-col justify-center items-center h-screen">
        <FormProvider {...resetForm}>
          <Outlet />
        </FormProvider>
      </main>
    </div>
  );
}
export default AuthPage;
